import { http_client } from '../plugins/http_client';

const authIP = process.env.VUE_APP_AUTH_BASE_URL;
const urlUser = '/api/v1/users/initial';
const urlCatalogos = '/api/v1/catalogos';
const headers = {
      'Content-Type': 'application/json',
      "Cache-Control": "no-cache",
}
const getUsuariosCargaInicial = async (params = {}, token) =>{
    headers.Authorization = `Bearer ${token}`;
    const query = new URLSearchParams(params).toString();
    const response = await fetch(`${authIP}${urlUser}/index?${query}`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody?.message || `Error HTTP ${response.status}`);
  }

  const data = await response.json();
  const paginationHeaders = {
    total: Number(response.headers.get("total_rows")),
    per_page: Number(response.headers.get("per_page")),
    current_page: Number(response.headers.get("page")),
  };
  return { data, headers: paginationHeaders };
};

const getTiposEstablecimientos = async (token) => {
     headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${authIP}${urlCatalogos}/tipo-establecimiento`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody?.message || `Error HTTP ${response.status}`);
  }

  const data = await response.json();
  return { data };
}

const getEstablecimientos = async (token,params) => {
     headers.Authorization = `Bearer ${token}`;
    const query = new URLSearchParams(params).toString();
    const response = await fetch(`${authIP}${urlCatalogos}/establecimientos?${query}`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody?.message || `Error HTTP ${response.status}`);
  }

  const data = await response.json();
  return { data };
}

const postUsuario = async (body,token) => {
    console.log(token);
    
     headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${authIP}${urlUser}`,{
    method: 'POST',
    headers,
     body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody?.message || `Error HTTP ${response.status}`);
  }

  const status = response.status;
  const data = await response.json();
  return { data,status };
}
const putUsuario = async (id,body,token) => {
     headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${authIP}${urlUser}/${id}`,{
    method: 'PUT',
    headers,
     body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody?.message || `Error HTTP ${response.status}`);
  }

  const status = response.status;
  const data = await response.json();
  return { data, status };
}

const deleteUsuario = async (id,token) => {
     headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${authIP}${urlUser}/${id}`,{
    method: 'DELETE',
    headers,
  });

  if (!response.ok) {
    throw {
      status: response.status,
      data: content,
      message: content?.err?.description || 'Error al eliminar usuario'
    };
  }

  const status = response.status;
  const data = await response.json();
  return { data, status };
}

export default {
  getUsuariosCargaInicial,
  getTiposEstablecimientos,
  getEstablecimientos,
  postUsuario,
  putUsuario,
  deleteUsuario,
};
